import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import _ from 'lodash';

const Cell = styled.div`
    padding: 15px 10px;
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .name {
        padding: 0 10px;
        white-space: nowrap;
    }

    .side {
        width: calc(50% - 25px);
        display: flex;
        padding: 0 5px;
        align-items: center;
        justify-content: center;
    }
    .status {
        font-size: 13px;
        line-height: 18px;
        margin-bottom: 5px;
        text-align: center;
    }

    .score {
        width: 50px;
        text-align: center;
        display: inline-block;
        font-size: 20px;
    }
    .rnd {
        position: absolute;
        top: 5px;
        left: 5px;
        font-size: 12px;
    }
`;

const CellSmall = Cell.extend`
    width: 280px;
    height: 60px;
    margin: 1px;
    background: ${props => (props.active ? `rgba(255, 0, 0, 0.1)` : `rgba(0, 0, 0, 0.05)`)};
    &:hover {
        background: rgba(255, 0, 0, 0.1);
        cursor: pointer;
    }
`;

export const Player = ({ name, number, stats = {}, onClick, active }) => (
    <CellSmall onClick={onClick} active={active}>
        <div>{name}</div>
        {_.get(stats, 'matchesPlayed', 0)} / {_.get(stats, 'goals', 0)} / {_.get(stats, 'assists', 0)}
    </CellSmall>
);

// label={
//     p.name +
//     ' ' +
//     `${_.get(p, 'stats.matchesPlayed', 0)} / ${_.get(p, 'stats.goals', 0)} / ${_.get(
//         p,
//         'stats.assists',
//         0,
//     )}`
// }

export default Player;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/components/PlayerCell.js
 **/